import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import Loader from '../Loader'
import Userdashboardheader from '../userdashboardheader/Userdashboardheader'
import DashboardTopbar from './DashboardTopbar'
import PageHero from './PageHero'

// Dashboard page showing one of the user's record lists (deposits, withdrawals, ...) as a table.
// `getRows(user)` picks the list; `columns` is [{ label, render(row, user) }].
const HistoryPage = ({ route, topbarTitle, hero, heroAside, sectionTitle, columns, getRows, emptyText, emptyAction }) => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(true)
  const [user, setUser] = useState(null)

  useEffect(() => {
    const getData = async () => {
      const token = localStorage.getItem('token')
      if (!token) { navigate('/login'); return }
      try {
        const data = await (await fetch(`${route}/api/getData`, {
          headers: { 'x-access-token': token, 'Content-Type': 'application/json' },
        })).json()
        if (data.status === 'error') { localStorage.removeItem('token'); navigate('/login') }
        else setUser(data)
      } catch { navigate('/login') }
      finally { setLoader(false) }
    }
    getData()
  }, [navigate, route])

  const rows = (user && getRows(user)) || []

  return (
    <div className="ud-layout">
      {loader && <Loader />}
      <Userdashboardheader route={route} />

      <div className="ud-main">
        <DashboardTopbar route={route} title={topbarTitle} />

        <div className="ud-content">
          <PageHero {...hero}>{user && heroAside ? heroAside(user, rows) : null}</PageHero>

          <div className="ud-section-header">
            <h2>{sectionTitle}</h2>
            <p>{rows.length} record{rows.length === 1 ? '' : 's'}</p>
          </div>

          {rows.length > 0 ? (
            <div className="ud-table-wrap">
              <table className="ud-table">
                <thead>
                  <tr>{columns.map(col => <th key={col.label}>{col.label}</th>)}</tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={row.id || index}>
                      {columns.map(col => <td key={col.label}>{col.render(row, user)}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : !loader && (
            <div className="ud-card ud-empty">
              <p>{emptyText}</p>
              {emptyAction && <Link to={emptyAction.to} className="ud-btn-primary">{emptyAction.label}</Link>}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default HistoryPage
